import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

/**
 * Aviso global quando uma operação da loja é bloqueada por mensalidade em atraso.
 * Garante caminho claro para pagamento sem depender do e-mail do dono.
 */
export function SubscriptionOverdueNotice() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    /** @param {CustomEvent<{ error?: string }>} event */
    function onOverdue(event) {
      const text =
        typeof event?.detail?.error === 'string' && event.detail.error.trim()
          ? event.detail.error.trim()
          : 'Mensalidade em atraso — a loja está pausada até regularizar.';
      setMessage(text);
    }

    window.addEventListener('ominia:subscription-overdue', onOverdue);
    return () => window.removeEventListener('ominia:subscription-overdue', onOverdue);
  }, []);

  if (!message) {
    return null;
  }

  return (
    <div
      className="-mt-2 mb-6 rounded-2xl border border-rose-500/40 bg-gradient-to-r from-rose-500/15 to-orange-500/10 px-4 py-3 text-sm backdrop-blur dark:from-rose-950/35 dark:to-orange-950/25"
      role="alert"
    >
      <p className="font-semibold text-ink dark:text-mist">Operação pausada por mensalidade</p>
      <p className="mt-1 leading-relaxed text-ink/85 dark:text-mist/90">{message}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Link
          to="/app/mensalidade"
          className="inline-flex items-center justify-center rounded-xl bg-ink px-4 py-2 text-xs font-bold uppercase tracking-wide text-mist shadow-sm transition hover:opacity-90 dark:bg-mist dark:text-ink"
        >
          Pagar no portal
        </Link>
        <button
          type="button"
          onClick={() => setMessage('')}
          className="inline-flex items-center justify-center rounded-xl border border-ink/15 bg-white/70 px-4 py-2 text-xs font-semibold text-ink dark:border-white/15 dark:bg-white/10 dark:text-mist"
        >
          Fechar aviso
        </button>
      </div>
    </div>
  );
}
